import AOS from 'aos';
import { useEffect, useRef, useState, } from 'react';
import Modal from 'react-bootstrap/Modal';
import { PiSealCheckBold } from "react-icons/pi";
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import Chart from 'react-apexcharts';
import { Bar } from "react-chartjs-2";
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, getDateAndTime, handleDateChange } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, DateBox } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const Dashboard = () => {
    const inputrefs = useRef([]);
    const dispatch = useDispatch();
    const [barChartData, setBarChartData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [CheckAll, setCheckAll] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [dashboard, setDashboard] = useState({})
    const [currentPageNo, setCurrentPageNo] = useState(1)

    //initial states
    const [DetailType, setDetailType] = useState('')
    const [result, setResult] = useState({})
    const [formData, setFormData] = useState({
        "fromDate": getDateAndTime(30).date,
        "toDate": getDateAndTime().date,
        "dealer": '',
        "OnlinePaymentID": ''
    })

    let ss = barChartData || [];
    let data = [];
    if (ss !== undefined && ss !== null) {
        for (let i = 0; i < ss.length; i++) {
            data.push({
                bookingDate: ss[i].bookingDate,
                pending: ss[i].pending,
                delivered: ss[i].delivered,
                totalOrder: ss[i].totalSale,
                rto: ss[i].rto,
                ofd: ss[i].ofd,
            });
        }
    };

    var totalOrder = data.map((i) => i.totalOrder);
    var bookingDate = data.map((it) => (it.bookingDate));

    const value = {
        labels: bookingDate,
        datasets: [
            {
                label: "Total Sale",
                backgroundColor: "#28a745",
                borderColor: "black",
                data: totalOrder,
            }

        ],
    };

    const availableData = [
        //{ value: parseInt(dashboard.completedSales), label: 'Completed Sales', color: '#28A745' },
        { value: parseInt(dashboard.paidByDealer), label: 'Paid by Dealer', color: '#28A745' },
        { value: parseInt(dashboard.paidbyCustomer), label: 'Paid by Customer', color: '#FFC107' },
        { value: parseInt(dashboard.pendingSales), label: 'Pending Sales', color: '#FD7E14' },
        { value: parseInt(dashboard.cancelledSales), label: 'Cancelled Sales', color: '#E57373' },
        { value: parseInt(dashboard.paymentPendingFromCustomer), label: 'Payment Pending from Customer', color: '#DC3545' },
        { value: parseInt(dashboard.failedSales), label: 'Failed Sales', color: '#17A2B8' },
        { value: parseInt(dashboard.paidbutPolicyNotGenerated), label: 'Paid but Policy Not Generated', color: '#007BFF' }
    ];

    const filteredData = availableData.filter(item => item.value > 0);

    const chartData = {
        series: filteredData.map(item => item.value),
        options: {
            title: {
                text: "Sales Data",
                align: "center",
            },
            chart: {
                type: 'pie',
                height: 475,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: true
                }
            },

            labels: filteredData.map(item => item.label),
            colors: filteredData.map(item => item.color),
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '14px',
                labels: {
                    colors: ['#000000'],
                }
            },
            responsive: [{
                breakpoint: 768,
                options: {
                    chart: {
                        height: 400
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }, {
                breakpoint: 480,
                options: {
                    chart: {
                        height: 300
                    },
                    legend: {
                        fontSize: '12px'
                    }
                }
            }]
        }
    };



    const getDashboardData = async () => {
        await dispatch(setSubLoading(true))
        let res = await ApiCall(`/api/Dashboard/GetDashboardData`, { ...formData })
        if (res.status === "SUCCESS" || res.status === "ERROR") {
            setDashboard({ ...res })
            getDashboardChartData();
        }
        else if (res.status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
        await dispatch(setSubLoading(false))
    }

    const GetModelData = async (CurrentPage, type) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            Type: 'S',
            PageIndex: `${PageIndex}`,
        }
        await setResult({})
        await setDetailType(type)
        await setIsLoading(true)
        await dispatch(setSubLoading(true))
        let res = await ApiCall(`/api/Dashboard/GetDashboardDetail`, { ...formData, DetailType: type, ...data })
        await setIsLoading(false)
        if (res.Status === "SUCCESS") {
            await setResult({ ...res })
            await setIsModalOpen(true)
        }
        if (res.Status === "ERROR") {
            await setResult({ ...res })
        }
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        GetModelData(value, DetailType);
    };

    let ExportRequest = {
        ...formData,
        Type: 'E',
        PageIndex: '1',
        DetailType: DetailType
    }
    const handleSubmitRef = async () => {

        await dispatch(setSubLoading(true));
        await setIsModalOpen(false);

        // Array of OnlinePaymentIDs 
        for (const paymentID of formData.OnlinePaymentID) {
            try {

                let data = await ApiCall(`/api/SalesEntryAPI/GeneratePolicyNo`, { OnlinePaymentID: paymentID.toString() });
                await NotificationSound(data.status, data.message, data.focus, inputrefs, () => GetModelData(currentPageNo, 'PaidbutPolicyNotGenerated'));
            } catch (error) {
                console.error("Error during API call for OnlinePaymentID:", paymentID, error);
            }
        }
        await dispatch(setSubLoading(false));
    };

    //const handleSubmitRef = async () => {
    //    await dispatch(setSubLoading(true))
    //    await setIsModalOpen(false)

    //    let data = await ApiCall(`/api/SalesEntryAPI/GeneratePolicyNo`, { OnlinePaymentID: (formData.OnlinePaymentID).toString() || '' })
    //    await dispatch(setSubLoading(false))
    //    if (data.status === 'SUCCESS') {
    //        await NotificationSound(data.status, data.message, data.focus, inputrefs, () => GetModelData(currentPageNo, 'PaidbutPolicyNotGenerated'));
    //    }
    //    else if (data.status === 'ERROR' || data.status === 'UNAUTHORIZED' || data.status === 'EXPIRED') {
    //        await NotificationSound(data.status, data.message, data.focus, inputrefs);
    //        await setIsModalOpen(true)
    //    }
    //};



    const handleCheck = (id, OnlinePaymentID, i) => {
        const updatedTableData = result?.Data.map((item, index) => {
            if (index === i) {
                return {
                    ...item,
                    checkStatus: !item.checkStatus
                };
            }
            return item;
        });
        setResult(prevResult => ({
            ...prevResult,
            Data: updatedTableData
        }));
        const updatedOnlinePaymentID = updatedTableData
            .filter(item => item.checkStatus)
            .map(item => item.Checkbox);

        setFormData({ ...formData, OnlinePaymentID: updatedOnlinePaymentID });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = result?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setResult(prevOnlinePaymentID => ({
            ...prevOnlinePaymentID,
            Data: updatedTableData
        }));
        const updatedOnlinePaymentID = value ? result?.Data.map(item => item.Checkbox) : [];
        setFormData({ ...formData, OnlinePaymentID: updatedOnlinePaymentID });
    };

    const handleClear = async () => {
        formData.fromDate = getDateAndTime(30).date;
        formData.toDate = getDateAndTime().date;
        formData.dealer = '';
        await getDashboardData()
       // await getDashboardChartData()
        inputrefs.current['txtFromDate'].focus()
    }
    const getDashboardChartData = async () => {
        await dispatch(setSubLoading(true))
        let res = await ApiCall(`/api/Dashboard/GetChartData`, { ...formData })
        await dispatch(setSubLoading(false))
        if (res.status === 'EXPIRED' || data.status === 'UNAUTHORIZED') {
            await NotificationSound(res.status, res.message, res.focus, inputrefs);
        } else {
            setBarChartData(res.dailySaleDetails)
        }
    }
    useEffect(() => {
        document.title = 'Dashboard'
        getDashboardData()
        //getDashboardChartData()
        AOS.init(
            {
                duration: 1000,
            }
        );
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">  {'Dashboard'} </h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDealer'].focus() };
                            }}
                        />
                        <AutoCompleteBoxNew
                            id="txtDealer"
                            placeholder="Dealer"
                            label={'Dealer'}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtbtn'].focus()
                                }
                            }}
                            contextKey={formData.dealer}
                            autocompleteType='GetDealerMaster'
                            value={formData.dealer || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, dealer: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={getDashboardData}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>

                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
                <div className='row p-2'>
                    <div className='mb-3'>
                    </div>
                    {/*---------- Total Dealer Start -----------*/}
                    <div className='col-sm-6 col-lg-3' >
                        <div className='main-card card rounded border-0 shadow-sm' >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-info'>Total Dealers</h6>
                                <i className='fa-regular fa-user text-info' style={{ fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1 text-info' data-aos="fade-right" style={{ fontSize: '2rem' }}>
                                        <i className='fa-regular fa-user'></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold text-info" >{dashboard.totalDealer}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*---------- Total Dealers End -----------*/}
                    {/*---------- Success Start -----------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard.completedSales > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard.completedSales > 0 && GetModelData(currentPageNo, 'CompletedSales')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-success'>Completed Sales</h6>
                                <PiSealCheckBold size={24} className='text-success' />
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1' data-aos="fade-right" style={{ fontSize: '2rem', color: '#198754' }}>
                                        <PiSealCheckBold />
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#198754' }}>{dashboard.completedSales}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*---------- Success End -----------*/}
                    {/*-------------------- Paid By Dealer------------------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard?.paidByDealer > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard?.paidByDealer > 0 && GetModelData(currentPageNo, 'PaidByDealer')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-success'> Paid By Dealer</h6>
                                <i className='fa-solid fa-wallet' style={{ color: "#28a745", fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-wallet' style={{ color: "#28a745" }}></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#28a745' }}>{dashboard?.paidByDealer}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*-------------------- Paid By Dealer end------------------*/}
                    {/*-------------------- Paid By Customer------------------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard?.paidbyCustomer > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard?.paidbyCustomer > 0 && GetModelData(currentPageNo, 'PaidbyCustomer')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-warning'> Paid By Customer</h6>
                                <i className='fa-solid fa-money-bill' style={{ color: "#ffc107", fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-money-bill' style={{ color: "#ffc107" }}></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#ffc107' }}>{dashboard?.paidbyCustomer}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*-------------------- Paid By Customer End------------------*/}

                    {/*---------- Pending Start -----------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard.pendingSales > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard.pendingSales > 0 && GetModelData(currentPageNo, 'PendingSales')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-warning'>Pending Sales</h6>
                                <i className='fa-solid fa-hourglass-half text-warning' style={{ fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon3' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-hourglass-half'></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#FDB31B' }}>{dashboard.pendingSales}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*---------- Pending End -----------*/}
                    {/*---------- Cancelled Sales Start -----------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard.cancelledSales > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard.cancelledSales > 0 && GetModelData(currentPageNo, 'CancelledSales')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-danger'> Cancelled Sales</h6>
                                <i className='fa-solid fa-ban text-danger' style={{ fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon2' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-ban' style={{ color: "white" }}></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#DC3545' }}>{dashboard.cancelledSales}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*---------- Cancelled Sales End -----------*/}

                    {/*-------------------- Payment Pending From Customer------------------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard?.paymentPendingFromCustomer > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard?.paymentPendingFromCustomer > 0 && GetModelData(currentPageNo, 'PaymentPendingFromCustomer')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-danger'>Payment Pending From Customer</h6>
                                <i className='fa-solid fa-clock' style={{ color: "#dc3545", fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-clock' style={{ color: "#dc3545" }}></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#dc3545' }}>{dashboard?.paymentPendingFromCustomer}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*-------------------- Payment Pending From Customer End------------------*/}
                    {/*-------------------- Failed Sales Start------------------*/}
                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard?.failedSales > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard?.failedSales > 0 && GetModelData(currentPageNo, 'FailedSales')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0' style={{ color: "#17a2b8" }}>Failed Sales</h6>
                                <i className='fa-solid fa-exclamation-circle' style={{ color: "#17a2b8", fontSize: '24px' }}></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-exclamation-circle' style={{ color: "#17a2b8" }}></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#17a2b8' }}>{dashboard?.failedSales}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*--------------------Failed Sales End------------------*/}
                    {/*---------- Paid but Policy Not Generated Start -----------*/}

                    <div className='col-sm-6 col-lg-3' style={{ cursor: "pointer" }}>
                        <div className='main-card card rounded border-0 shadow-sm' data-bs-toggle="modal"
                            data-bs-target={dashboard.paidbutPolicyNotGenerated > 0 ? "#exampleModal" : ""}
                            onClick={() => dashboard.paidbutPolicyNotGenerated > 0 && GetModelData(currentPageNo, 'PaidbutPolicyNotGenerated')}
                        >
                            <div className='card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h6 className='card-title mb-0 text-primary'>Paid but Policy Not Generated</h6>

                                <i className='fa-solid fa-clipboard-question' style={{ color: "#4E95FC", fontSize: '24px' }} ></i>
                            </div>
                            <div className='card-body text-center'>
                                <div className='d-flex align-items-center p-2'>
                                    <div className='dash-icon1' data-aos="fade-right" style={{ fontSize: '2rem', color: 'white' }}>
                                        <i className='fa-solid fa-clipboard-question' style={{ color: "#4E95FC" }}></i>
                                    </div>
                                    <div className='ms-3'>
                                        <h5 className="m-0 fw-bold" style={{ color: '#4E95FC' }}>{dashboard.paidbutPolicyNotGenerated}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*---------- Paid but Policy Not Generated End-----------*/}
                </div>
                <Modal show={isModalOpen} style={{ cursor: 'pointer' }} backdrop="static" onHide={() => setIsModalOpen(false,)} size="xl">
                    <Modal.Header closeButton style={{ background: "mintcream" }}>
                        <Modal.Title><h5 className="modal-title d-flex" id="exampleModalLabel">
                            {
                                (DetailType === 'CompletedSales' && 'Completed Sales') ||
                                (DetailType === 'PaidByDealer' && 'Paid By Dealer') ||
                                (DetailType === 'PaidbyCustomer' && 'Paid by Customer') ||
                                (DetailType === 'PendingSales' && 'Pending Sales') ||
                                (DetailType === 'CancelledSales' && 'Cancelled Sales') ||
                                (DetailType === 'PaymentPendingFromCustomer' && 'Payment Pending From Customer') ||
                                (DetailType === 'FailedSales' && 'Failed Sales') ||
                                (DetailType === 'PaidbutPolicyNotGenerated' && 'Paid but Policy Not Generated')
                            }
                        </h5></Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ background: "mintcream", maxHeight: '450px', padding: '8px' }} className='modal-body table-responsive'>
                        <Table
                            PageName={'Dashboard'}
                            loading={isLoading}
                            tableData={result}
                            handleCheck={handleCheck}
                            handleCheckAll={handleCheckAll}
                            CheckAll={CheckAll}
                            currentPageNo={currentPageNo}
                            handleChange1={handleChange1}
                            Filter={false}
                            onlyFilterPage={true}
                        />
                    </Modal.Body>
                    <Modal.Footer style={{ background: "mintcream" }}>
                        <button type="button"
                            onClick={() => handleDownloadExcel(`/api/Dashboard/GetDashboardDetail`, ExportRequest, DetailType)}
                            className="btn btn-rounded btn-warning btn-sm"
                        >
                            <span className=" text-success me-2">
                                <i className="fa fa-download text-white color-success">
                                </i>
                            </span>Export
                        </button>
                        {DetailType === 'PaidbutPolicyNotGenerated' &&
                            <button type="button"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Are you sure?",
                                        text: "Do you want to generate policy for this sale ?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes",
                                        keydownListenerCapture: true,
                                        stopKeydownPropagation: false,
                                        didOpen: () => {
                                            document.addEventListener('keydown', function (event) {
                                                if (event.key === 'Y' || event.key === 'y') {
                                                    Swal.clickConfirm();
                                                } else if (event.key === 'N' || event.key === 'n') {
                                                    Swal.clickCancel();
                                                }
                                            });
                                        }
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            handleSubmitRef()
                                        }
                                    });
                                }}
                                className="btn btn-rounded btn-success btn-sm"
                            >
                                <span className=" text-success me-2">
                                    <i className="fa fa-save text-white color-success">
                                    </i>
                                </span>Generate Policy
                            </button>
                        }
                    </Modal.Footer>
                </Modal>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className='main-card card border-0'>
                        {chartData.series && chartData.series.length > 0 && chartData.series.some(value => value > 0) ? (
                            <Chart
                                options={chartData.options}
                                series={chartData.series}
                                type="pie"
                                height={chartData.options.chart.height}
                                width={chartData.options.chart.width}
                            />
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: '#888' }}>
                                No Record Found!
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12">
                    <div className="card mb-4">
                        <h6 className="m-0 fw-bold pt-2  text-center">Days Wise Sale</h6>
                        <div className="card-body">
                            <div className="chart-area" >
                                <Bar data={value} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Dashboard;

